import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SsoAuthService } from '@core/services/auth/sso-auth.service';

@Component({
  template: '<div class="flex justify-center items-center h-full">Slutför inloggningen, vänligen vänta...</div>',
  host: { class: 'h-full' },
  standalone: true,
})
export class SsoAuthCallbackComponent implements OnInit {
  private ssoAuthService = inject(SsoAuthService);
  private router = inject(Router);

  ngOnInit() {
    this.ssoAuthService
      .loginEnd()
      .pipe()
      .subscribe({
        next: (res) => console.log('[SSO-AUTH-CALLBACK COMPONENT] login end is done with response:', res),
        error: () => {
          this.router.navigate(['/login?error=FAILED_TO_END_LOGIN']);
        },
      });
  }
}
